import { render, staticRenderFns } from "./VesselIndex.vue?vue&type=template&id=70230a3a&scoped=true"
import script from "./VesselIndex.vue?vue&type=script&lang=js"
export * from "./VesselIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70230a3a",
  null
  
)

export default component.exports